import { render, staticRenderFns } from "./RessourceCard.vue?vue&type=template&id=66af49a8&"
import script from "./RessourceCard.vue?vue&type=script&lang=js&"
export * from "./RessourceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports